module.exports = __webpack_public_path__ + "img/no-data-new.cb6d7505.png";